import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

/**
 * Full-screen overlay that plays a "lights turning off / on" animation
 * when the user taps the ThemeToggle.
 *
 * - Renders ONLY on profile pages (add it to AdminProfilePage, StaffProfilePage,
 *   HostProfilePage, GuestProfilePage, VenueProfilePage).
 * - The overlay never receives pointer events so it doesn't block interaction.
 * - To-dark: deep charcoal blackout that fades in then out, revealing the dark theme.
 * - To-light: bright white flash that fades in then out, revealing the light theme.
 *
 * The accompanying CSS in index.css also adds a brightness burst to `.profile-name-card`
 * via the `html.theme-is-toggling` class, which is set for the same 1.8 s window.
 */
const ProfileThemeFlash = () => {
  const { isToggling, togglingToDark } = useTheme();
  if (!isToggling) return null;

  return (
    <div
      aria-hidden="true"
      className={`profile-theme-flash ${togglingToDark ? 'flash-to-dark' : 'flash-to-light'}`}
      style={{ position: 'fixed', inset: 0, zIndex: 8888, pointerEvents: 'none' }}
    />
  );
};

export default ProfileThemeFlash;
